import {randomColor} from '../../utils/utils'

export const ADD_COMPANY = 'ADD_COMPANY'

export function createCompanyIfNeeded(companyName) {
    return (dispatch, getState) => {
        if (!getState().companies[companyName]) {
            const colors = ((companyName === 'JobHunt')?{light: "#e8d5f0",dark: "#aa4dc8"} : randomColor())
            return dispatch(addCompany(companyName, {colors}))
        }
    }
}

function addCompany(companyName, companyData){
    return {
        type: ADD_COMPANY,
        companyName: companyName,
        companyData: companyData
    }
}